<!-- 商品管理 -->
<template>
  <div class="productManagement">
    <!-- 头部 -->

    <Head />
    <div class="detail">
      <div class="obody">
        <div class="tab">
          <div class="tabOpt" :class="{ act: val == item.value }" v-for="(item, index) in list" :key="index"
            @click="setRouter(item)">
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="view">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/header/detailHeader'
export default {
  components: {
    Head
  },
  computed: {
    list() {
      return [
        // 进行中的商品
        { name: this.$t('message.productsInProgress'), value: 'productsInProgress' },
        // 历史商品数据
        { name: this.$t('message.historicalProductData'), value: 'historicalProductData' },
        // 信息维护
        { name: this.$t('message.informationMaintenance'), value: 'informationMaintenance' },
      ]
    },
  },
  data() {
    return {
      val: this.$route.name,
    };
  },
  created() {
    if (this.isAuth(608)) {
      this.list.push( // 商品数据分析
        { name: this.$t('message.productDataAnalysis'), value: 'productDataAnalysis' },)
    }
  },
  methods: {
    setRouter(item) {
      this.val = item.value
      if (this.$route.name == 'productManagement/' + item.value) return false
      this.$router.push(item.value)
    },
  }
}
</script>
<style lang='scss' scoped>
.productManagement {
  min-width: 1910px;

  .detail {

    margin: 24px 30px;


    .obody {


      margin-bottom: 16px;
      background: #f8f8f8;
      padding: 25px;
    }

    .tab {
      display: flex;
      background: #F8F8F8;
      align-items: center;
      border-bottom: 1px solid #edeff4;

      .tabOpt {
        height: 50px;
        min-width: 160px;
        padding: 0 30px;
        font-size: 18px;
        line-height: 50px;
        margin-bottom: -2px;
        box-sizing: border-box;
        text-align: center;
        border-top: solid 2px transparent;
        border-bottom: solid 2px transparent;
        cursor: pointer;

        &.act {
          color: #b4272d;
          border-top: solid 2px #b4272d;
          border-left: solid 1px #edeff4;
          border-right: solid 1px #edeff4;
          border-bottom: solid 2px #f8f8f8;
          background-color: #f8f8f8;
        }
      }
    }
  }
}
</style>
